<carousel [isAnimated]="true">
    <slide>

        <div class="img-banner d-flex justify-content-center  align-items-center row"
            style="background-image: url('https://images.xceed.me/static/b2cweb/home/xceed-events-clubs-djs-1.jpg?h=722&fm=auto');">
            <div style="        margin-top: 5vh;" class="col-12 text-center d-flex justify-content-center row">
                <h1 class="text-banner col-12 ">VIVE LA EXPERIENCIA</h1>
                <p (click)="goPage('/events')"
                    class="col-8 p-banner d-flex justify-content-center  align-items-center mt-3">
                    <mat-icon style="margin-right: 10px;" matSuffix>search</mat-icon> Haz click aqui para buscar eventos
                    futuros.
                </p>

            </div>
            <div
                class=" animate__animated animate__bounce animate__infinite	infinite   col-12 text-center d-flex justify-content-center row">
                <mat-icon (click)="moveId(home)" style="font-size: 70px; color: white;height: 100%;
                width: 100%;" matSuffix>expand_more</mat-icon>
            </div>

        </div>

    </slide>

    <slide>

        <div class="img-banner d-flex justify-content-center  align-items-center row"
            style="background-image: url('https://images.xceed.me/static/b2cweb/home/xceed-events-clubs-djs-11.jpg?h=722&fm=auto');">
            <div style="        margin-top: 5vh;" class="col-12 text-center d-flex justify-content-center row">
                <h1 class="text-banner col-12 ">VIVE LA EXPERIENCIA</h1>
                <p (click)="goPage('/events')"
                    class="col-8 p-banner d-flex justify-content-center  align-items-center mt-3">
                    <mat-icon style="margin-right: 10px;" matSuffix>search</mat-icon> Haz click aqui para buscar eventos
                    futuros.
                </p>

            </div>
            <div
                class=" animate__animated animate__bounce animate__infinite	infinite  col-12 text-center d-flex justify-content-center row">
                <mat-icon (click)="moveId(home)" style="font-size: 70px; color: white;height: 100%;
                width: 100%;" matSuffix>expand_more</mat-icon>
            </div>

        </div>

    </slide>

    <!-- <slide>

        <div class="img-banner d-flex justify-content-center  align-items-center row"
            style="background-image: url('https://images.xceed.me/static/b2cweb/home/xceed-events-clubs-djs-11.jpg?h=722&fm=auto');">
            <div class="col-12 text-center d-flex justify-content-center row">
                <h1 class="text-banner col-12 ">VIVE LA EXPERIENCIA</h1>
                <p (click)="goPage('/events')"
                    class=" col-8 p-banner d-flex justify-content-center align-items-center mt-3">
                    <mat-icon style="margin-right: 10px;" matSuffix>search</mat-icon> Haz click aqui para buscar eventos
                    futuros.
                </p>

            </div>
        </div>

    </slide> -->
    <!-- <slide>
        <img src="https://images.xceed.me/static/b2cweb/home/xceed-events-clubs-djs-11.jpg?h=722&fm=auto"
            alt="second slide" style="display: block; width: 100%;">
    </slide>
    <slide>
        <img src="https://images.xceed.me/static/b2cweb/home/xceed-events-clubs-djs-7.jpg?h=722&fm=auto"
            alt="third slide" style="display: block; width: 100%;"> -->
    <!-- </slide> -->
</carousel>


<div #home class="container " style="margin-top: -55px;
position: absolute;">
</div>

<div class="container " style="margin-top:-50px">

    <app-events-page></app-events-page>

</div>